<template>
	<div>
		<AdminAccountForm
			:loading="submitting"
			@submit="onSubmit"
			@cancel="onCancel"
		/>
	</div>
</template>

<script>
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import AdminAccountForm from '@/components/admin/AdminAccountForm'

export default {
	name: 'CreateAdminAccount',
	data() {
		return {
			submitting: false
		}
	},
	methods: {
		async onSubmit(data) {
			const body = JSON.stringify(data)
			this.submitting = true
			try {
				// Create the account
				await this.post('/auth/local/register', { body })
				this.toast(`Successfully *created* an account for *${data.username}*.`)

				// Navigate to manage accounts page
				this.$router.push({ name: 'Admin Accounts' })
			} catch (err) {
				switch (err.name) {
					case 'APIValidationError':
						this.toastWarn('Please check the account details and try again.')
						break
					default:
						this.toastErr(
							`Failed to create an account. Please try again later.`
						)
						break
				}
			}
			this.submitting = false
		},
		onCancel() {
			this.$router.go(-1)
		}
	},
	mixins: [api, toast],
	components: {
		AdminAccountForm
	}
}
</script>
